import Navbar from './Navbar';
import HomeMain from './HomeMain';
import SearchBar from './SearchBar';
import SearchResult from './SearchResult';

const Home = () => (
  <main>
    <Navbar />
    <HomeMain />
    <SearchBar />
    <SearchResult />
  </main>
);

export default Home;
